// @ts-nocheck
import * as React from "react";

const CaretLeft: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M13.789 7.155A.75.75 0 0 1 15 7.747v8.501a.75.75 0 0 1-1.212.591L8.29 12.581a.746.746 0 0 1 .001-1.183l5.498-4.243z"
            />
        </svg>
    );
};

export default React.memo(CaretLeft);
